<div class=" order_sum_wrapper ">
    <fieldset class="scheduler-border">
        <legend class="scheduler-border">Customer Search Criteria</legend>
        <div class="col-md-12">
            <form #searchOrder="ngForm" autocomplete="off">
                <div class="row">
                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback ">
                            <label for="dateFrom" class="control-label">Date From:</label>

                            <div class="input-group">
                                <input class="form-control" id="dateFrom" name="dateFrom" [(ngModel)]="DateFrom"
                                    (click)="dateFrom.toggle()" [maxDate]="DateTo" ngbDatepicker
                                    #dateFrom="ngbDatepicker" style="cursor: pointer;" readonly required>
                                <!-- <button class="btn btn-outline-secondary calendar" (click)="dateFrom.toggle()"
                                    type="button"></button> -->
                                <i (click)="dateFrom.toggle()" class="fa fa-calendar " aria-hidden="true"
                                    style="position: absolute;right: 6px;top: 5px;z-index: 9;"></i>


                            </div>


                        </div>
                    </div>
                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback">
                            <label for="DateTo" class="control-label">Date To:</label>
                            <div class="input-group">
                                <input class="form-control" id="DateTo" name="DateTo" [(ngModel)]="DateTo" ngbDatepicker
                                    [maxDate]="maxDate" [minDate]="DateFrom" (click)="dateTo.toggle()"
                                    #dateTo="ngbDatepicker" style="cursor: pointer;" readonly required>
                                <!-- <button class="btn btn-outline-secondary calendar" (click)="dateTo.toggle()"
                                    type="button"></button> -->
                                <i (click)="dateTo.toggle()" class="fa fa-calendar " aria-hidden="true"
                                    style="position: absolute;right: 6px;top: 5px;z-index: 9;"></i>


                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback">
                            <label  class="control-label">First Name</label>
                            <div class="input-group">
                                <input type="text" name="firstName" [(ngModel)]="customerModel.FirstName" placeholder="First Name">
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback">
                            <label  class="control-label">Last Name</label>
                            <div class="input-group">
                                <input type="text" name="lastName" [(ngModel)]="customerModel.LastName" placeholder="Last Name">
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback">
                            <label  class="control-label">Account No</label>
                            <div class="input-group">
                                <input type="text" name="AccountNo" [(ngModel)]="customerModel.AccountNo" placeholder="Account No">
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback">
                            <label  class="control-label">Invoice No</label>
                            <div class="input-group">
                                <input type="text" name="InvoiceNo" [(ngModel)]="customerModel.InvoiceNo" placeholder="Invoice No">
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback">
                            <label  class="control-label">Franchise:</label>
                            <div class="input-group">
                                <select class="customer_select" *ngIf="FranchiseList"
                                [(ngModel)]="customerModel.FranchiseId" name="FranchiseId" required>
                                <option value="">--- Please select ---</option>
                                <option *ngFor="let Franchise of FranchiseList"
                                    [value]="Franchise.Value">{{Franchise.Text}}</option>
                            </select>
                            </div>
                        </div>
                    </div> -->
                   
                   
                  

                    <div class="col-sm-6 order_sum_col">
                        <div class="form-group orders_sum_top ">
                            <div class="pull-right">
                                <button type="submit" class="btn btn-primary button_ri8"
                                    (click)="getCustomers(1)">Search</button>
                                <button type="button" (click)="clear()" class="btn btn-default">Clear</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </fieldset>

    <fieldset class="scheduler-border clearfix marign_10">
        <legend class="scheduler-border">Customers List</legend>

        <div class="panel_table">
            <div class="panel panel-default ">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>

                                <th>Acc.#</th>
                                <th>Customer Name </th>
                                <th>Email </th>
                                <th> Phone</th>
                                <th>Zip Code</th>
                                <th>Registration Date</th>
                                <!-- <th>Orders</th> -->
                                <th colspan="2" class="text-center">Action</th>

                            </tr>
                        </thead>
                        <tbody *ngIf="SearchCustomerSummary">
                            <tr *ngFor="let data of SearchCustomerSummary?.customerSummary">
                                <td>{{data.AccountNo}}</td>
                                <td>{{data.FirstName}} {{data.LastName}}</td>
                                <td>{{data.Email}}</td>
                                <td>{{data.Phone}}</td>
                                <td>{{data.ZipCode}}</td>
                                <td>{{data.RegistrationDate | date: 'MM/dd/yyyy hh:mm:ss'}}</td>
                                <!-- <td>{{data.OrderCount}}</td> -->
                                <td class="hyperlink_name"><a (click)="getCustomerProfile(data.ID)">View Profile</a></td>
                                <td class="hyperlink_name"><a (click)="getCustomerTransactionDetail(data.ID)">View Invoice</a></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class=" paraNoRec">
                        <p *ngIf="SearchCustomerSummary?.customerSummary.length === 0">No Record Found</p>
                    </div>
                    <div *ngIf="SearchCustomerSummary?.PaginatedResult?.TotalRecords > 10" style="float: right;">
                        <ngb-pagination [(page)]="customerModel.PageNo" [maxSize]="10"
                            [collectionSize]="SearchCustomerSummary?.PaginatedResult?.TotalRecords" [ellipses]="true"
                            [boundaryLinks]="true" (pageChange)="getCustomers($event)">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>



</div>

<ng-template #orderCancel let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Select Reason for Cancal Order</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="col-sm-12 modal_col field">
        <div class="modal-body class-of-dropdown">
            <!-- <p>One fine body&hellip;</p> -->
            <select [(ngModel)]="orderSearchCriteria.CancelReasonId" name="cancelReason" class="form-control">
                <option disabled selected value="">--- Please Select ---</option>
                <option *ngFor="let orderCancelReason of OrderCancelReason" [value]="orderCancelReason.Id">
                    {{orderCancelReason.Name}}</option>
            </select>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Ok</button>
    </div>
</ng-template>